var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.59436 0 0 5.59516 0 12.5C0 19.4048 5.59516 25 12.5 25C19.4056 25 25 19.4048 25 12.5C25 5.59516 19.4048 0 12.5 0ZM18.6395 8.56371L16.5879 18.2315C16.4363 18.9169 16.0282 19.0831 15.4589 18.7605L12.3339 16.4573L10.8266 17.9089C10.6605 18.075 10.5194 18.2161 10.1968 18.2161L10.4185 15.0355L16.2097 9.80323C16.4621 9.58145 16.154 9.45565 15.821 9.67742L8.66371 14.1831L5.57903 13.2202C4.90887 13.0089 4.89355 12.55 5.72016 12.2274L17.7718 7.57984C18.3315 7.37823 18.8202 7.71613 18.6387 8.5629L18.6395 8.56371Z",
    fill: "#4D525A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.fdea265a9658100d14b3882a0d55e3c3.svg";
export { ForwardRef as ReactComponent };